module.exports = __webpack_public_path__ + "img/project.31e9df83.png";